
define('modules/application/wizard/steps/zoneStep/complexZoneStep/zonesMenuView',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "../zonesMenuView",
  "./zoneMenuView",
  "../separatorMenuView"
],

function(
  app,
  Backbone,
  jQueryUi,
  ZonesMenuView,
  ZoneMenuView,
  SeparatorMenuView) {

  var complexZonesMenuView = ZonesMenuView.extend({

    addConstructors : function() {
      this.ZoneMenuView      = ZoneMenuView;
    },

    insertAdditionalZones : function(_fromClick) {
      //Variable declarations
      var viewToSelect,
          that            = this, viewToInsert,
          fromClick       = false,
          additionalZones = this.model.additionalZones, additionalZonesLength = additionalZones.length;

      var regularZonesLength = this.model.collection.length;

      if(_fromClick)
        fromClick = _fromClick;

      //Inserting views for the additional zones
      for (i=0; i<additionalZonesLength; i++)
      {
        if (additionalZones[i].role!=="separator")
        {
          additionalZones[i].set("stepEventAggregator", that.options.stepEventAggregator);
          additionalZones[i].set("sortable", false);
          viewToInsert = new that.ZoneMenuView({model : additionalZones[i], stepEventAggregator : that.options.stepEventAggregator});

          if (typeof filterId !== 'undefined')
            if ( (i===0) && ( (filterId===-1) || (filterId===1) || (filterId===2) ) )
              viewToSelect = viewToInsert;

          viewToInsert.setAsLocked();
          that.insertView("#zoneList", viewToInsert);

          if ( i===0 )
            viewToSelect = viewToInsert;
        }
        else
        {
          viewToInsert = new that.SeparatorMenuView();
          viewToInsert.name = additionalZones[i].name;
          that.insertView("#zoneList", viewToInsert);
        } 
      }

      if (!fromClick)
        return viewToSelect;
    },

    insertRegularZones : function() {
      var number          = 1;
      var that            = this;
      var viewToSelect;

      //Inserting views for the classic zones
      this.model.collection.each(function(currentModel) {
        currentModel.set("number", number);
        currentModel.set("sortable", true);
        viewToInsert = new that.ZoneMenuView({model : currentModel, stepEventAggregator : that.options.stepEventAggregator});
        if (i===0)
          viewToSelect=viewToInsert;
        that.insertView("#zoneList", viewToInsert);
        number++;
      });

      return viewToInsert;
    },

    beforeRender : function() {
      var viewToSelect;
      viewToSelect = this.insertAdditionalZones();

      if (this.model.collection.length>0)
        viewToSelect = this.insertRegularZones();
      else
        this.insertRegularZones();

      if (viewToSelect)
        window.BticinoS4B.eventAggregator.trigger("zone:selected", viewToSelect);
    },

    afterRender  : function() {
      var that        = this;

      //$(this.el).find(".zones").mCustomScrollbar({advanced:{updateOnContentResize: true}});
      if (this.model.collection.at(0)) {
        $(this.el).find(".zones").sortable({
          update: function(event, ui) { that.sortZones(); that.options.stepEventAggregator.trigger("order:changed");},
          items : "li:not(.outOfCollection):not(.locked):not(.separator)"
        });
      }

      $(this.el).find(".zones").disableSelection();

      var menuView        = this.$el;
      var menuTitleView   = menuView.find(".titleBar");
      var menuZoneListView= menuView.find("#zoneList");

      // menuZoneListView.height(menuView.height()-menuTitleView.height());
    }
  });

  //Creating final complexZoneStep class
  complexZonesMenuView.extend({
    objClass      : "complexZonesMenuView"
  });

  // Required, return the module for AMD compliance
  return complexZonesMenuView;

});